"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PluginDefinition_1 = require("./PluginDefinition");
const PluginNotFoundError_1 = require("../Error/PluginNotFoundError");
const WidgetError_1 = require("../Error/WidgetError");
/**
 * Base plugin manager service.
 */
class PluginManagerBase {
    /**
     * Constructs the plugin manager.
     *
     * @param {PluginDefinition[]} definitions
     * @param {ContainerAwareFactory} containerAwareFactory
     */
    constructor(containerAwareFactory, definitions) {
        /**
         * Contains all definitions.
         */
        this.definitions = [];
        this.definitions = Array.from(definitions);
        this.containerAwareFactory = containerAwareFactory;
        this.validate();
    }
    /**
     * Validates definitions.
     * @TODO: validator service.
     */
    validate() {
        const ids = {};
        this.definitions.forEach((definition) => {
            if (ids[definition.getId()]) {
                throw new WidgetError_1.default(`Duplicate plugin id: '${definition.getId()}'.`);
            }
            ids[definition.getId()] = true;
        });
    }
    /**
     * Adds a plugin definition.
     *
     * @param {PluginDefinition} definition
     */
    addDefinition(definition) {
        this.definitions.push(definition);
        this.validate();
        return this;
    }
    /**
     * Gets the plugin definitions.
     *
     * @param {boolean} prioritize
     * @return {PluginDefinition[]}
     */
    getDefinitions(prioritize = true) {
        let definitions = Array.from(this.definitions || []);
        if (prioritize) {
            definitions.sort((a, b) => b.getPriority() - a.getPriority());
        }
        return definitions;
    }
    /**
     * Gets plugin definition.
     *
     * @param {string} id
     * @return {PluginDefinition | undefined}
     */
    getDefinition(id) {
        return this.definitions.find((def) => def.getId() === id);
    }
    /**
     * Creates specific plugin instance.
     *
     * @param {string | PluginDefinition} id
     * @param padArgs
     * @return {PluginBase}
     */
    create(id, ...padArgs) {
        let definition = id instanceof PluginDefinition_1.default ? id : this.getDefinition(id);
        if (!(definition instanceof PluginDefinition_1.default)) {
            throw new PluginNotFoundError_1.default(`Could not create plugin instance. Plugin definition '${id}' not found.`);
        }
        return this.containerAwareFactory.create(definition.getClass(), definition, ...padArgs);
    }
    /**
     * Creates all plugins.
     *
     * @param {*[]} padArgs
     * @param {boolean} prioritize
     * @return {PluginBase[]}
     */
    createAll(padArgs = [], prioritize = true) {
        return this.getDefinitions(prioritize)
            .map((def) => this.create(def.getId(), ...padArgs));
    }
}
exports.default = PluginManagerBase;
